import _taggedTemplateLiteral from "@babel/runtime/helpers/taggedTemplateLiteral";
var _templateObject;
import { gql } from "../../utils/gqlClient";
import { wrapQuery } from "../../utils/wrapQuery";
import { getClientId } from "../../index";
export { resetPassword };
var resetPasswordMutation = gql(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n  mutation ResetPassword($clientId: String!, $newPassword: String!, $token: String!) {\n    resetPassword(clientId: $clientId, newPassword: $newPassword, token: $token) {\n      status\n      token\n    }\n  }\n"])));
async function resetPassword(newPassword, token) {
  var data = await wrapQuery('resetPassword', resetPasswordMutation, {
    clientId: getClientId(),
    newPassword: newPassword,
    token: token
  });
  return data.resetPassword;
}